import { render, staticRenderFns } from "./FireLedgerDetail.vue?vue&type=template&id=d80ae5dc&scoped=true"
import script from "./FireLedgerDetail.vue?vue&type=script&lang=js"
export * from "./FireLedgerDetail.vue?vue&type=script&lang=js"
import style0 from "./FireLedgerDetail.vue?vue&type=style&index=0&id=d80ae5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80ae5dc",
  null
  
)

export default component.exports